function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#000000",
    d: "M 249.5,-0.5 C 253.5,-0.5 257.5,-0.5 261.5,-0.5C 265.479,1.31481 268.312,4.31481 270,8.5C 270.667,28.5 270.667,48.5 270,68.5C 264.008,78.6057 255.841,80.7724 245.5,75C 243.383,73.2691 241.883,71.1024 241,68.5C 240.333,48.5 240.333,28.5 241,8.5C 242.688,4.31481 245.521,1.31481 249.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.936
    },
    fill: "#000000",
    d: "M 81.5,69.5 C 86.5483,69.127 91.215,70.2936 95.5,73C 107.333,84.8333 119.167,96.6667 131,108.5C 136.237,117.036 135.403,124.869 128.5,132C 121.635,135.57 114.968,135.237 108.5,131C 96.6667,119.167 84.8333,107.333 73,95.5C 66.761,83.7179 69.5943,75.0512 81.5,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.936
    },
    fill: "#000000",
    d: "M 422.5,69.5 C 439.728,70.9539 444.894,79.6205 438,95.5C 426.167,107.333 414.333,119.167 402.5,131C 396.032,135.237 389.365,135.57 382.5,132C 375.597,124.869 374.763,117.036 380,108.5C 391.833,96.6667 403.667,84.8333 415.5,73C 417.925,71.7874 420.259,70.6207 422.5,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#000000",
    d: "M 244.5,127.5 C 297.139,125.732 337.639,146.732 366,190.5C 390.712,237.489 389.046,283.489 361,328.5C 326.621,373.413 281.454,390.579 225.5,380C 183.994,368.821 154.494,343.655 137,304.5C 117.015,246.605 129.515,197.105 174.5,156C 195.287,140.102 218.62,130.602 244.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#000000",
    d: "M -0.5,261.5 C -0.5,257.5 -0.5,253.5 -0.5,249.5C 1.31481,245.521 4.31481,242.688 8.5,241C 28.5,240.333 48.5,240.333 68.5,241C 78.6057,246.992 80.7724,255.159 75,265.5C 73.2691,267.617 71.1024,269.117 68.5,270C 48.5,270.667 28.5,270.667 8.5,270C 4.31481,268.312 1.31481,265.479 -0.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#000000",
    d: "M 511.5,249.5 C 511.5,253.5 511.5,257.5 511.5,261.5C 509.685,265.479 506.685,268.312 502.5,270C 482.5,270.667 462.5,270.667 442.5,270C 432.394,264.008 430.228,255.841 436,245.5C 437.731,243.383 439.898,241.883 442.5,241C 462.5,240.333 482.5,240.333 502.5,241C 506.685,242.688 509.685,245.521 511.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.936
    },
    fill: "#000000",
    d: "M 114.5,376.5 C 132.881,376.922 138.381,385.589 131,402.5C 119.167,414.333 107.333,426.167 95.5,438C 83.8396,444.336 75.3396,441.502 70,429.5C 69.1234,424.456 70.1234,419.789 73,415.5C 84.8333,403.667 96.6667,391.833 108.5,380C 110.727,379.059 112.727,377.892 114.5,376.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.936
    },
    fill: "#000000",
    d: "M 387.5,376.5 C 392.947,375.826 397.947,376.992 402.5,380C 414.333,391.833 426.167,403.667 438,415.5C 444.76,429.239 440.76,437.906 426,441.5C 422.237,441.135 418.737,439.968 415.5,438C 403.667,426.167 391.833,414.333 380,402.5C 373.559,391.008 376.059,382.342 387.5,376.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#000000",
    d: "M 261.5,511.5 C 257.5,511.5 253.5,511.5 249.5,511.5C 245.521,509.685 242.688,506.685 241,502.5C 240.333,482.5 240.333,462.5 241,442.5C 246.992,432.394 255.159,430.228 265.5,436C 267.617,437.731 269.117,439.898 270,442.5C 270.667,462.5 270.667,482.5 270,502.5C 268.312,506.685 265.479,509.685 261.5,511.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeDarkIcon);
export default __webpack_public_path__ + "static/media/theme_dark_icon.88b482f83151c85fd750b4f9d481f3dc.svg";
export { ForwardRef as ReactComponent };